module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-600italic.f3d4de8d.woff";